import React from 'react';
import _ from 'lodash';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

class Cat extends PositionedGoodyHOC {
	// 7
	render() {
		const style = {
			st146: {
				fill: 'none',
			},
			st3: {
				fill: '#A5C6EF',
			},
			st9: {
				fill: '#EFEFEF',
			},
		};

		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} style={style.st146} cx="58.325573" cy="22.7614727" />
				<path style={style.st3} d="M115.2070312,7.3284988c-7.46875-3.2841797-14.0214844-4.9707031-18.6572266-5.8354492
					c-1.3532715-0.3239746-2.7919922-0.5524902-4.296875-0.7062988C91.3466797,0.6705399,89.2910156,0.5040359,89.25,0.5040359
					c-8.6540527,0-16.2253418,4.7481689-20.3032227,11.7320557c-2.1030273-1.3481445-5.9042969-3.2543335-10.4838867-3.2543335
					c-4.5786133,0-8.3789062,1.9377747-10.4816895,3.2859192C43.9035645,5.2837906,36.3327637,0.4141769,27.6787109,0.4141769
					c-0.0283203,0-0.1154785,0.0085602-0.126709,0.0088043c-1.0476074,0.0056152-2.0778809,0.1674805-3.0891113,0.3066406
					c-1.4199219,0.1552734-2.7802734,0.4202881-4.0634766,0.729126C15.7705078,2.3259354,9.2382812,4.0335159,1.7929688,7.3074417
					C0.703125,7.7859573,0,8.8846512,0,10.0745926v2.3564453c0,0.8916016,0.3964844,1.7368164,1.0820312,2.3066406
					c1.2373047,1.0292969,2.7382812,3.8598633,3.1103516,7.6430664c0.0068359,0.0715332,0.0283203,0.137207,0.0402832,0.2070312
					c-0.0314941,0.4963379-0.0529785,0.9953613-0.0529785,1.4995117c0,12.9570312,10.5419922,23.4985352,23.4990234,23.4985352
					h0.0009766c6.2763672,0,12.1767578-2.4443359,16.6142578-6.8823242
					c4.4384766-4.4384766,6.8828125-10.3393555,6.8828125-16.6162109c0-2.1318359-0.2905273-4.1960449-0.8249512-6.1608887
					c0.8540039-0.6477051,4.1374512-2.923584,8.111084-2.923584c3.9711914,0,7.2568359,2.2749023,8.1132812,2.9233398
					c-0.534668,1.9648438-0.8251953,4.0292969-0.8251953,6.1611328c0,12.9570312,10.5419922,23.4985352,23.4990234,23.4985352
					s23.4990234-10.5415039,23.4990234-23.4985352c0-0.4589844-0.0166016-0.9140625-0.0427246-1.3666992
					c0.0244141-0.112793,0.0546875-0.2231445,0.0661621-0.3408203c0.3691406-3.7597656,1.8886719-6.597168,3.1455078-7.6420898
					C116.6035156,14.1678543,117,13.3226395,117,12.4310379v-2.3564453C117,8.8846512,116.296875,7.8070145,115.2070312,7.3284988z
					 M40.0517578,36.4608231c-3.3056641,3.3051758-7.6992188,5.125-12.3730469,5.125
					c-9.6494141,0-17.4990234-7.8496094-17.4990234-17.4985352c0-8.359375,5.8955078-15.3591309,13.7451172-17.083252
					c2.2109375-0.3278809,3.5527344-0.4035645,3.7832031-0.4143066c9.6347656,0.0161133,17.46875,7.8583984,17.46875,17.4975586
					C45.1767578,28.7616043,43.3564453,33.1556473,40.0517578,36.4608231z M89.25,41.5858231
					c-9.6494141,0-17.4990234-7.8496094-17.4990234-17.4985352c0-9.6472168,7.8469238-17.4960938,17.4938965-17.4987793
					c0.1535645,0.0065918,1.4611816,0.0710449,3.671875,0.3930664c7.8937988,1.6906738,13.8322754,8.7148438,13.8322754,17.1057129
					C106.7490234,33.7362137,98.8994141,41.5858231,89.25,41.5858231z" />
				<path style={style.st9} d="M112,12.5028152h-3c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3
					c0.828125,0,1.5,0.6713867,1.5,1.5S112.828125,12.5028152,112,12.5028152z" />
				<path style={style.st9} d="M8,12.5028152H5c-0.828125,0-1.5-0.6713867-1.5-1.5s0.671875-1.5,1.5-1.5h3
					c0.828125,0,1.5,0.6713867,1.5,1.5S8.828125,12.5028152,8,12.5028152z" />
			</g>
		);
	}
}

class Tortoise extends PositionedGoodyHOC {
	// 7
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="30.9125538" cy="11.8440666" />
				<path fill="#A5C6EF" d="M61.0597267,3.6645906c-3.9584389-1.7406152-7.431385-2.6344726-9.8883286-3.0927882
					c-0.7172356-0.1717065-1.4797592-0.2928198-2.2773438-0.3743384c-0.4803123-0.0615918-1.5698166-0.1498389-1.5915527-0.1498389
					c-4.5866508,0-8.5994339,2.5165296-10.7607079,6.2179899c-1.1146049-0.7145166-3.1292801-1.7247968-5.5564613-1.7247968
					c-2.4266663,0-4.4408207,1.0270205-5.5552959,1.7415371C23.2688885,2.5808952,19.2563648,0,14.6697168,0
					c-0.0150099,0-0.061204,0.0045369-0.0671558,0.0046663c-0.555232,0.0029761-1.1012764,0.0887646-1.637229,0.1625195
					c-0.7525587,0.0822949-1.4735451,0.2227527-2.1536427,0.3864368C8.3583689,1.013232,4.8962889,1.9182496,0.9502735,3.6534302
					C0.3726563,3.9070437,0,4.4893513,0,5.1200204v1.2489161C0,6.841485,0.2101367,7.2894492,0.5734766,7.5914559
					c0.6557715,0.545527,1.4512892,2.0457273,1.6484864,4.0508246c0.003623,0.0379133,0.0150096,0.0727205,0.0213501,0.1097269
					c-0.0166919,0.2630596-0.0280788,0.5275412-0.0280788,0.7947416c0,6.8672256,5.587256,12.4542236,12.454483,12.4542236h0.0005178
					c3.3264751,0,6.4536819-1.2954979,8.8055573-3.6476326c2.3523922-2.3523922,3.6478901-5.4798584,3.6478901-8.806591
					c0-1.1298733-0.1539803-2.2239037-0.4372253-3.2652712c0.4526234-0.3432837,2.1928501-1.5494995,4.2988758-1.5494995
					c2.1047325,0,3.8461227,1.205698,4.3000374,1.5493698c-0.283371,1.0413675-0.4373512,2.1355276-0.4373512,3.2654009
					c0,6.8672256,5.5872536,12.4542236,12.454483,12.4542236s12.4544792-5.586998,12.4544792-12.4542236
					c0-0.2432623-0.0087967-0.4844532-0.022644-0.7243509c0.0129395-0.0597801,0.0289841-0.1182661,0.0350685-0.1806345
					c0.1956444-1.9926758,1.0009956-3.4964991,1.6671181-4.0503078c0.3633385-0.3020067,0.5734749-0.7499709,0.5734749-1.2225194
					V5.1200204C62.0099983,4.4893513,61.6373444,3.9182038,61.0597267,3.6645906z M21.2274323,19.104723
					c-1.7520027,1.7517433-4.0805874,2.7162495-6.5577154,2.7162495c-5.1141891,0-9.2744827-4.1602936-9.2744827-9.2742233
					c0-4.4304695,3.124619-8.1403399,7.2849116-9.0541239c1.1717968-0.1737769,1.8829498-0.2138891,2.0050983-0.2195826
					c5.1064253,0.0085402,9.2584372,4.1649513,9.2584372,9.2737064
					C23.9436817,15.0241365,22.9789162,17.3529797,21.2274323,19.104723z M47.3025017,21.8209724
					c-5.114193,0-9.2744827-4.1602936-9.2744827-9.2742233c0-5.1130252,4.1588669-9.2729301,9.2717628-9.274353
					c0.0813904,0.0034935,0.7744255,0.0376537,1.9460945,0.2083251c4.183712,0.8960571,7.3311043,4.6188674,7.3311043,9.0660286
					C56.5769806,17.6606789,52.4166908,21.8209724,47.3025017,21.8209724z" />
				<path fill="#EFEFEF" d="M59.3600006,6.4069781h-1.5900002c-0.4389076,0-0.795002-0.355835-0.795002-0.7949996
					c0-0.4391651,0.3560944-0.7950001,0.795002-0.7950001h1.5900002c0.4389038,0,0.7949982,0.355835,0.7949982,0.7950001
					C60.1549988,6.0511432,59.7989044,6.4069781,59.3600006,6.4069781z" />
				<path fill="#EFEFEF" d="M4.2399998,6.4069781H2.6500001c-0.4389064,0-0.7950001-0.355835-0.7950001-0.7949996
					c0-0.4391651,0.3560936-0.7950001,0.7950001-0.7950001h1.5899997c0.4389067,0,0.7950001,0.355835,0.7950001,0.7950001
					C5.0349998,6.0511432,4.6789064,6.4069781,4.2399998,6.4069781z" />
			</g>
		);
	}
}

class Chicken extends PositionedGoodyHOC {
	// 7
	render() {
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="40.8279" cy="15.64311" r="0" />
				<path fill="#A5C6EF" d="M80.64492,4.84003c-5.22813-2.29893-9.81504-3.47949-13.06006-4.08481
					c-0.94729-0.22678-1.95439-0.38674-3.00781-0.49441c-0.63437-0.08135-2.07334-0.1979-2.10205-0.1979
					c-6.05783,0-11.35774,3.32372-14.21225,8.21244c-1.47212-0.9437-4.13301-2.27803-7.33872-2.27803
					c-3.20503,0-5.86523,1.35644-7.33718,2.30014C30.73249,3.40873,25.43293,0,19.3751,0c-0.01982,0-0.08084,0.00599-0.0887,0.00616
					c-0.73333,0.00393-1.45452,0.11724-2.16238,0.21465c-0.99395,0.10869-1.94619,0.2942-2.84443,0.51039
					C11.03936,1.33823,6.4668,2.53354,1.25508,4.82529C0.49219,5.16025,0,5.92933,0,6.76229V8.4118
					c0,0.62412,0.27754,1.21577,0.75742,1.61465c0.86611,0.72051,1.9168,2.7019,2.17725,5.35015
					c0.00479,0.05007,0.01982,0.09605,0.0282,0.14492c-0.02205,0.34744-0.03709,0.69675-0.03709,1.04966
					c0,9.06992,7.37939,16.44897,16.44932,16.44897h0.00068c4.39346,0,8.52373-1.71104,11.62998-4.81763
					c3.10693-3.10693,4.81797-7.23755,4.81797-11.63135c0-1.49229-0.20337-2.93723-0.57747-4.31262
					c0.5978-0.45339,2.89621-2.04651,5.67776-2.04651c2.77983,0,5.07978,1.59243,5.6793,2.04634
					c-0.37427,1.37539-0.57764,2.82051-0.57764,4.31279c0,9.06992,7.37939,16.44897,16.44931,16.44897
					s16.44932-7.37905,16.44932-16.44897c0-0.32129-0.01162-0.63984-0.02991-0.95669c0.01709-0.07896,0.03828-0.1562,0.04631-0.23857
					c0.2584-2.63184,1.32207-4.61802,2.20186-5.34946C81.62246,9.62757,81.9,9.03592,81.9,8.4118V6.76229
					C81.9,5.92933,81.40781,5.17499,80.64492,4.84003z M28.03623,25.23265c-2.31396,2.31362-5.38945,3.5875-8.66113,3.5875
					c-6.75459,0-12.24932-5.49473-12.24932-12.24897c0-5.85156,4.12686-10.75139,9.62158-11.95828
					c1.54766-0.22952,2.48691-0.2825,2.64824-0.29001c6.74434,0.01128,12.22812,5.50088,12.22812,12.24829
					C31.62373,19.8432,30.34951,22.91903,28.03623,25.23265z M62.475,28.82015c-6.75459,0-12.24931-5.49473-12.24931-12.24897
					c0-6.75305,5.49284-12.24727,12.24573-12.24915c0.10749,0.00461,1.02283,0.04973,2.57031,0.27515
					c5.52566,1.18347,9.68259,6.10039,9.68259,11.974C74.72432,23.32543,69.22959,28.82015,62.475,28.82015z" />
				<path fill="#EFEFEF" d="M78.4,8.46205h-2.1c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1
						c0.57969,0,1.05,0.46997,1.05,1.05S78.97969,8.46205,78.4,8.46205z" />
				<path fill="#EFEFEF" d="M5.6,8.46205H3.5c-0.57969,0-1.05-0.46997-1.05-1.05s0.47031-1.05,1.05-1.05h2.1
					c0.57969,0,1.05,0.46997,1.05,1.05S6.17969,8.46205,5.6,8.46205z" />
			</g>
		);
	}
}


function Blue(props) {
	const glasses = {
		Cat,
		Tortoise,
		Chicken,
	};

	const ThisBlue = glasses[props.petType.name] || Cat;

	if (_.isUndefined(ThisBlue)) {
		return null;
	}

	return <ThisBlue {...props} />;
}

export default Blue;



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Glasses/Blue.js